import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  ViewChild,
  type OnInit,
  inject,
} from '@angular/core';
import QRCode from 'qrcode';
import { DialogBottomUpComponent } from '../dialog-bottom-up/dialog-bottom-up.component';
import { ImagePipe } from '@pipes/image.pipe';
import { UserService } from '@services/user.service';
import { IconComponent } from '@components/icon/icon.component';

@Component({
  selector: 'market-qr-dialog',
  standalone: true,
  imports: [DialogBottomUpComponent, IconComponent],
  templateUrl: './qr-dialog.component.html',
  styleUrl: './qr-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ImagePipe],
})
export class QrDialogComponent implements OnInit, AfterViewInit {
  @Input() data = '';
  @Input() avatar = '';
  @Input() name = '';
  @ViewChild('canvas') canvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('dialog') dialog!: ElementRef<HTMLDialogElement>;

  private imagePipe = inject(ImagePipe);
  private userService = inject(UserService);

  ngOnInit(): void {}
  ngAfterViewInit(): void {
    QRCode.toCanvas(
      this.canvas.nativeElement,
      this.data,
      {
        errorCorrectionLevel: 'H',
      },
      function (error) {
        if (error) console.error(error);
      }
    );
    setTimeout(() => {
      this.drawAvatar();
    }, 100);
  }

  private drawAvatar() {
    const ctx = this.canvas.nativeElement.getContext('2d');
    if (!ctx || !this.avatar) return;
    const width = this.canvas.nativeElement.width;
    const height = this.canvas.nativeElement.height;
    const cWidth = 50;
    const img = new Image();
    img.src = this.imagePipe.transform(this.avatar);
    const centerX = width / 2;
    const centerY = height / 2;
    img.onload = () => {
      ctx.save();
      ctx.beginPath();
      ctx.arc(centerX, centerY, cWidth / 2, 0, Math.PI * 2, true);
      ctx.closePath();
      ctx.clip();

      ctx.drawImage(
        img,
        centerX - cWidth / 2,
        centerY - cWidth / 2,
        cWidth,
        cWidth
      );
      ctx.beginPath();
      ctx.arc(centerX, centerY, cWidth / 2, 0, Math.PI * 2, true);
      ctx.clip();
      ctx.closePath();
      ctx.restore();

      ctx.textAlign = 'center';
      ctx.font = '20px Arial';
      ctx.fillStyle = 'white'; // Set the text color to white
      ctx.shadowColor = 'black'; // Set the text shadow color to black
      ctx.shadowOffsetX = 1; // Set the horizontal offset of the text shadow to 2 pixels
      ctx.shadowOffsetY = 1; // Set the vertical offset of the text shadow to 2 pixels
      ctx.shadowBlur = 0; // Set the blur radius of the text shadow to 2 pixels

      // Measure the text width
      const textWidth = ctx.measureText(this.name).width;

      // Draw a semi-transparent black background for the text
      ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
      ctx.fillRect(
        centerX - textWidth / 2 - 5,
        centerY + cWidth / 2 - 1,
        textWidth + 10,
        20
      );
      // Reapply the text shadow before drawing the text
      ctx.shadowBlur = 1;
      // Draw the text
      ctx.fillStyle = 'white';
      ctx.fillText(this.name, centerX, centerY + cWidth / 2 + 15);
    };
  }

  public showModal() {
    this.dialog.nativeElement.showModal();
  }
  public hideModal() {
    this.dialog.nativeElement.close();
  }

  download() {
    this.userService
      .downloadQR(this.data, this.imagePipe.transform(this.avatar), this.name)
      .subscribe(res => {
        const link = document.createElement('a');
        link.download = 'qr.png';
        link.href = res.data;
        document.body.appendChild(link);
        link.click();
      });
  }
}
